import { Outlet } from 'react-router-dom';

/**
 * Workspace-subdomain pass-through.
 *
 * Onboarding is now an APEX-ONLY single-page create form (see OnboardingEntry):
 * once a workspace exists you're on its subdomain and there is no onboarding
 * page to run there — `/onboarding` on a subdomain only bounces back to root.
 * So gating subdomain routes on `onboarding_state` could only ever produce a
 * redirect loop (guard → /onboarding → OnboardingPage bounces to / → guard …),
 * which is exactly what migrated workspaces (onboarding_state !== 'DONE') hit.
 *
 * Workspace existence + membership is already enforced by WorkspaceShell's /me
 * call, and the post-create setup wizard is gated separately by
 * RequireSetupComplete. So this guard is intentionally a no-op pass-through.
 *
 * Spec: docs/superpowers/specs/2026-05-26-role-aware-auth-invite-flow-design.md §3.
 */
export function RequireOnboardingComplete() {
  return <Outlet />;
}
